import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { normalizePublicPublishers } from './normalizePublicPublisher';
import { getRecommendationsAPI } from './api';

// Subscriber-personalized — /user/recommendations requires a logged-in
// session (subscriber JWT). Anonymous visitors never call it; the
// Recommended section itself stays hidden without a subscriber.
async function getRecommendedPublishers() {
    const session = this.env.session;
    if (!session?.token) return;

    this.observed.recommendedPublishersLoading = true;
    try {
        const traceId = this.env.traceId;
        const timezone = this.env.countryInfo?.timezone;

        const res = await getRecommendationsAPI({ token: session.token, traceId, timezone });
        const data = res?.data?.data || res?.data || null;
        const publishers = data?.publishers || [];

        this.recommendedPublishers = assignPublisherColors(normalizePublicPublishers(publishers));
        this.observed.recommendedPublishers = uuidv4();
    } finally {
        this.observed.recommendedPublishersLoading = false;
    }
}

export default getRecommendedPublishers;
